import UPButton from 'components/button';
import { UPTanStackTableColumn } from 'components/tanstack-table';
import { AbsenceReasonPolicy } from 'constants/AbsenceReasonPolicy';
import { TFunction } from 'i18next';
import {
  ABSENCE_REASON__DEACTIVATED_BADGE,
  ABSENCE_REASON__OPTIONAL,
  ABSENCE_REASON__PROOF,
  ABSENCE_REASON__REASON,
  ABSENCE_REASON__REMARK,
  ABSENCE_REASON__REMUN_CODE,
  ABSENCE_REASON__REMUN_CODE_DESCRIPTION,
  ABSENCE_REASON__REQUIRED,
  GENERAL__EDIT,
} from 'translations/constants';
import { IAbsenceReason } from 'types/absence-reason/IAbsenceReason';
import { getReasonName } from 'utils/absence-reason';
import { DeactivatedLabel } from './styles';

const policyLabel = (t: TFunction, policy: AbsenceReasonPolicy) =>
  t(policy === AbsenceReasonPolicy.REQUIRED ? ABSENCE_REASON__REQUIRED : ABSENCE_REASON__OPTIONAL);

/** Built outside the component: TanStack calls each `cell` as a component (react/no-unstable-nested-components). */
export const buildAbsenceReasonColumns = (
  t: TFunction,
  language: string,
  onEdit: (row: IAbsenceReason) => void,
): UPTanStackTableColumn<IAbsenceReason>[] => [
  { id: 'name', header: t(ABSENCE_REASON__REASON), cell: ({ row }) => getReasonName(row, language) },
  {
    id: 'remunCodeDescription',
    header: t(ABSENCE_REASON__REMUN_CODE_DESCRIPTION),
    accessorKey: 'remunCodeDescription',
  },
  { id: 'remunCode', header: t(ABSENCE_REASON__REMUN_CODE), cell: ({ row }) => row.remunCode ?? '' },
  { id: 'remark', header: t(ABSENCE_REASON__REMARK), cell: ({ row }) => policyLabel(t, row.remarkPolicy) },
  { id: 'proof', header: t(ABSENCE_REASON__PROOF), cell: ({ row }) => policyLabel(t, row.proofPolicy) },
  {
    id: 'actions',
    header: '',
    align: 'right',
    cell: ({ row }) =>
      row.isActive ? (
        <UPButton
          text={t(GENERAL__EDIT)}
          outlined
          onClick={() => onEdit(row)}
          testId={`absence-reason-edit-${row.id}`}
        />
      ) : (
        <DeactivatedLabel data-testid={`absence-reason-deactivated-${row.id}`}>
          {t(ABSENCE_REASON__DEACTIVATED_BADGE)}
        </DeactivatedLabel>
      ),
  },
];
